import { AsyncReturnType } from "type-fest";

import { ConnectionService } from "@/services";
import { UseMutationSimpleOptions, useMutation } from "@/services/hooks";

type Variables = Parameters<typeof ConnectionService.verifyLinkedInAccount>[0];
type Data = AsyncReturnType<typeof ConnectionService.verifyLinkedInAccount>;
type Error = unknown;

export const useVerifyLinkedInAccount = <TContext = unknown>(
  options?: UseMutationSimpleOptions<Data, Error, Variables, TContext>
) => {
  const result = useMutation<Data, Error, Variables, TContext>(
    ConnectionService.verifyLinkedInAccount,
    options
  );

  return result;
};
